import React from 'react';
import NewGridRowCard from '../NewGridRowCard';

const NewDashboardListByRow = ({canalEstado, setShowModalAnular, setIdCreditAnular,solicitations }) => {
  return (
    <>
      {solicitations.map((solicitation, solicitationKey) => (
        <NewGridRowCard
          key={solicitationKey}
          item={solicitation}
          canalEstado={canalEstado}
          setShowModalAnular={setShowModalAnular}
          setIdCreditAnular={setIdCreditAnular}
        />
      ))}
    </>
  );
};

export default NewDashboardListByRow;
